exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2pqjPdjf1NuN2ZBbkbMLQ6 {\n    margin-bottom: 32px;\n    margin-top: 32px;\n}", ""]);

// exports
exports.locals = {
	"root": "_2pqjPdjf1NuN2ZBbkbMLQ6"
};